import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";

const GenerateCode = () => {
  const genCode = `<div id="embedded-form1"></div><div id="embedded-form1_1" ></div><div id="embedded-form1_2" ></div><div id="embedded-form2"></div>
    <link rel="stylesheet" href="https://api.smarttaxdocs.com/css/your-embed-script.css">
    <script src="https://cdn.tutorialjinni.com/intl-tel-input/17.0.8/js/intlTelInput.min.js"></script>
    <script src="https://api.smarttaxdocs.com/js/your-embed-script.js"></script>`;

  const genHealthCode = `<meta charset="UTF-8"><div id="health-insurance-embedded-form1"></div><div id="health-insurance-embedded-thanks"></div><link rel="stylesheet" href="https://api.smarttaxdocs.com/css/health-insurance-embed-script.css"><script src="https://api.smarttaxdocs.com/js/intl-tel-input-master/build/js/intlTelInput.min.js"></script><script src="https://api.smarttaxdocs.com/js/health-insurance-embed-script.js"></script>
    `;
  const [showtext, setShowText] = useState(false);

  function isCopySupported() {
    return document.queryCommandSupported("copy");
  }

  function copyToClipboard(type) {
    if (isCopySupported()) {
      // Use the Clipboard API if available (modern browsers)
      navigator.clipboard
        .writeText(type == "user" ? genCode : genHealthCode)
        .then(() => {
          setShowText(true);
        })
        .catch((error) => {
          console.error("Failed to copy text: ", error);
        });
    } else {
      // Fallback to execCommand for older browsers
      const textArea = document.createElement("textarea");
      textArea.value = genCode;
      document.body.appendChild(textArea);
      textArea.select();

      try {
        const successful = document.execCommand("copy");
        if (successful) {
          setShowText(true);
        }
      } catch (err) {
        console.error("Copy failed: ", err);
      } finally {
        document.body.removeChild(textArea);
      }
    }
  }

  useEffect(() => {
    if (showtext) {
      setTimeout(() => {
        setShowText(false);
      }, 4000);
    }
  }, [showtext]);

  return (
    <div>
      <div className="main-coupon-discount">
        <Container>
          <Row>
            <Col md={12} className="text-center gen-code">
              <div className="tooltip-div pt-4 text-start">
                <h2>Generate Embed Code</h2>
              </div>

              {/* <OverlayTrigger
                delay={{ hide: 450, show: 300 }}
                overlay={(props) => (
                  <Tooltip {...props}>
                    {showtext ? "Copied" : "Copy Code and paste in your site"}
                  </Tooltip>
                )}
                placement="top"
              > */}
              <div>
                <h6 className="">Tax Settlement Code</h6>
                <div
                  className="div generate-code"
                  onClick={() => copyToClipboard("user")}
                >
                  {`<div id="embedded-form1"></div><div id="embedded-form1_1" ></div><div id="embedded-form1_2" ></div><div id="embedded-form2"></div><div id="embedded-thanks"></div>
<link rel="stylesheet" href="https://api.smarttaxdocs.com/css/your-embed-script.css">
<script src="https://cdn.tutorialjinni.com/intl-tel-input/17.0.8/js/intlTelInput.min.js"></script>
<script src="https://api.smarttaxdocs.com/js/your-embed-script.js"></script>`}
                </div>
              </div>
              <div>
                <h6 className="mt-3">Health Insurance Code</h6>
                <div
                  className="div generate-code"
                  onClick={() => copyToClipboard("health")}
                >
                  {`<meta charset="UTF-8"><div id="health-insurance-embedded-form1"></div><div id="health-insurance-embedded-thanks"></div><link rel="stylesheet" href="https://api.smarttaxdocs.com/css/health-insurance-embed-script.css"><script src="https://api.smarttaxdocs.com/js/intl-tel-input-master/build/js/intlTelInput.min.js"></script><script src="https://api.smarttaxdocs.com/js/health-insurance-embed-script.js"></script>`}
                </div>
                {/* </OverlayTrigger> */}
                <p className="copied-text pt-2">
                  {showtext
                    ? "Code is Copied!"
                    : "Click on code to copy and paste in your site."}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default GenerateCode;
